/* ============================================================
   Chronic — Bundle Subscription Widget (shared across bundles)
   Two options: One-Time | Subscribe & Save 10%.

   PROGRESSIVE ENHANCEMENT:
   - Native Shopify Add to cart stays visible until this script confirms it has
     taken over (adds `bsub-js-ready` to <body>, which also reveals the widget).
   - If the script fails to load/run, the native button stays and customers can
     always buy. A broken script can't block a sale.
   - Adds the customer's CURRENTLY SELECTED variant (read live from the page),
     so it works for any bundle variant as long as they share one price.
   ============================================================ */
(function () {
  try {
    var MAX_QTY = 20;

    function money(cents) {
      try {
        return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
    function rootOf(el) { return el && el.closest ? el.closest('.bsub') : null; }
    function cfg(root, name) { return parseInt(root.getAttribute('data-' + name), 10); }
    function qtyEl(root, opt) { return root.querySelector('#bsub-qty-' + opt); }
    function getQty(root, opt) {
      var el = qtyEl(root, opt);
      var n = el ? parseInt(el.value, 10) : 1;
      return (isNaN(n) || n < 1) ? 1 : n;
    }
    function refreshPrices(root) {
      var compare = cfg(root, 'compare');
      var price = cfg(root, 'price');
      var disc = cfg(root, 'discount');
      if (isNaN(disc)) disc = 0;

      // One-time: compare-at struck, bundle price shown, scaled by qty.
      var otQty = getQty(root, 'onetime');
      var otWas = root.querySelector('#bsub-ot-was');
      var otNow = root.querySelector('#bsub-ot-now');
      if (otWas && !isNaN(compare)) otWas.textContent = money(compare * otQty);
      if (otNow && !isNaN(price)) otNow.textContent = money(price * otQty);

      // Subscribe: compare-at (gross sum) struck, 10%-off price shown, by qty.
      var subQty = getQty(root, 'subscribe');
      var subWas = root.querySelector('#bsub-sub-was');
      var subNow = root.querySelector('#bsub-sub-now');
      if (!isNaN(price)) {
        var discounted = Math.round(price * subQty * (1 - disc / 100));
        if (subWas && !isNaN(compare)) subWas.textContent = money(compare * subQty);
        if (subNow) subNow.textContent = money(discounted);
      }
    }
    function selectedOption(root) {
      var el = root.querySelector('input[name="bsub-option"]:checked');
      return el ? el.value : 'onetime';
    }
    function syncSelected(root) {
      var cards = root.querySelectorAll('.bsub__card');
      for (var i = 0; i < cards.length; i++) {
        var input = cards[i].querySelector('.bsub__radio');
        cards[i].classList.toggle('bsub__card--selected', !!(input && input.checked));
      }
      var fw = root.querySelector('#bsub-freq-wrap');
      if (fw) fw.hidden = (selectedOption(root) !== 'subscribe');
      document.body.classList.toggle('bsub-hide-express', selectedOption(root) !== 'onetime');
    }
    function currentVariantId(root) {
      var live = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return live && live.value ? parseInt(live.value, 10) : cfg(root, 'fallback-variant');
    }
    function showError(root, msg) {
      var e = root.querySelector('#bsub-err');
      if (e) { e.textContent = msg; e.hidden = false; }
    }
    function hideError(root) { var e = root.querySelector('#bsub-err'); if (e) e.hidden = true; }

    function openCartDrawer() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      // If Upcart needs a specific event, add it here:
      // document.dispatchEvent(new CustomEvent('upcart:openCart'));
    }

    function addToCart(root) {
      hideError(root);
      var choice = selectedOption(root);
      var qty = getQty(root, choice);
      var btn = root.querySelector('#bsub-add');
      var freqSel = root.querySelector('#bsub-frequency');
      var item;

      if (choice === 'subscribe') {
        var planId = freqSel && freqSel.value ? parseInt(freqSel.value, 10) : null;
        if (!planId) { showError(root, 'Subscription is not available yet. Please choose another option.'); return; }
        item = { id: currentVariantId(root), quantity: qty, selling_plan: planId };
      } else {
        item = { id: currentVariantId(root), quantity: qty };
      }

      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
        .then(function () { openCartDrawer(); })
        .catch(function (x) { showError(root, (x && x.description) || 'Sorry, something went wrong. Please try again.'); })
        .then(function () { if (btn) btn.disabled = false; });
    }

    // ---- delegated events ----
    document.addEventListener('click', function (ev) {
      try {
        var step = ev.target.closest && ev.target.closest('.bsub__step');
        if (step) {
          ev.preventDefault();
          var root = rootOf(step);
          if (!root) return;
          var card = step.closest('.bsub__card');
          var radio = card && card.querySelector('.bsub__radio');
          if (radio && !radio.checked) { radio.checked = true; syncSelected(root); }
          var opt = step.getAttribute('data-qty');
          var dir = parseInt(step.getAttribute('data-dir'), 10);
          var el = qtyEl(root, opt);
          if (!el) return;
          var next = getQty(root, opt) + dir;
          if (next < 1) next = 1;
          if (next > MAX_QTY) next = MAX_QTY;
          el.value = next;
          refreshPrices(root);
          return;
        }
        var add = ev.target.closest && ev.target.closest('#bsub-add, .bsub__btn');
        if (add) {
          var root2 = rootOf(add);
          if (root2) { ev.preventDefault(); addToCart(root2); }
        }
      } catch (e) { /* never let a click handler break the page */ }
    });

    document.addEventListener('change', function (ev) {
      try {
        if (ev.target && ev.target.name === 'bsub-option') {
          var root = rootOf(ev.target);
          if (root) syncSelected(root);
        }
      } catch (e) { /* ignore */ }
    });

    function setup() {
      try {
        var roots = document.querySelectorAll('.bsub');
        var initialisedAny = false;
        for (var i = 0; i < roots.length; i++) {
          var root = roots[i];
          if (root.dataset.bsubReady) { initialisedAny = true; continue; }
          try {
            var freqSel = root.querySelector('#bsub-frequency');
            if (freqSel) {
              // Option labels come straight from the Recharge plan names
              // (e.g. "30 day subscription - Save 10%"). No relabeling, so
              // removing a plan in Recharge never mislabels the rest.
              var lbl = freqSel.closest('label');
              if (lbl) {
                lbl.addEventListener('click', function (e) {
                  if (e.target && e.target.closest('#bsub-frequency')) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                });
              }
              var stop = function (e) { e.stopPropagation(); };
              freqSel.addEventListener('pointerdown', stop);
              freqSel.addEventListener('mousedown', stop);
              freqSel.addEventListener('touchstart', stop, { passive: true });
            }
            refreshPrices(root);
            syncSelected(root);
            root.dataset.bsubReady = '1';
            initialisedAny = true;
          } catch (inner) { /* skip this instance, leave native button visible */ }
        }
        if (initialisedAny) document.body.classList.add('bsub-js-ready');
      } catch (e) { /* native button stays visible on total failure */ }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
    window.addEventListener('load', setup);
    setTimeout(setup, 500);
    setTimeout(setup, 1500);
  } catch (e) {
    /* Total failure: widget stays hidden, native Add to cart stays visible. */
  }
})();